"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cookieConsentManager = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.ends-with.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.json.parse.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createClass.js"));
var _defineProperty2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/defineProperty.js"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib/src/constants"));
var CookieConsentManager = /*#__PURE__*/function () {
  function CookieConsentManager() {
    (0, _classCallCheck2.default)(this, CookieConsentManager);
    (0, _defineProperty2.default)(this, "cookieName", 'lh_cookie_consent');
    (0, _defineProperty2.default)(this, "expirationDays", 180);
    (0, _defineProperty2.default)(this, "domain", null);
    (0, _defineProperty2.default)(this, "privacyPolicyUrl", 'https://lifehikes.com/privacy-policy/');
    // Default fallback
    (0, _defineProperty2.default)(this, "currentConsent", null);
    (0, _defineProperty2.default)(this, "callbacks", []);
    (0, _defineProperty2.default)(this, "initialized", false);
    (0, _defineProperty2.default)(this, "bannerEl", null);
    (0, _defineProperty2.default)(this, "modalEl", null);
    (0, _defineProperty2.default)(this, "styleEl", null);
    (0, _defineProperty2.default)(this, "cachedDeviceUuid", null);
  }
  return (0, _createClass2.default)(CookieConsentManager, [{
    key: "init",
    value: function init(options) {
      var _this = this;
      if (this.initialized) return;
      if (options) {
        if (options.cookieName) this.cookieName = options.cookieName;
        if (options.expirationDays) this.expirationDays = options.expirationDays;
        if (options.domain) this.domain = options.domain;
        if (options.privacyPolicyUrl) this.privacyPolicyUrl = options.privacyPolicyUrl;
      }
      this.currentConsent = this.readConsentCookie();
      if (this.currentConsent) {
        if (!this.currentConsent.deviceUuid) {
          this.currentConsent.deviceUuid = this.getOrCreateDeviceUuid();
          this.writeConsentCookie(this.currentConsent);
        }
      } else {
        this.getOrCreateDeviceUuid();
      }
      if (!this.currentConsent) {
        if (document.body) {
          this.showBannerAndModal();
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            return _this.showBannerAndModal();
          });
        }
      }
      this.initialized = true;
    }
  }, {
    key: "generateUUID",
    value: function generateUUID() {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: "getOrCreateDeviceUuid",
    value: function getOrCreateDeviceUuid() {
      if (this.currentConsent && this.currentConsent.deviceUuid) {
        return this.currentConsent.deviceUuid;
      }
      if (!this.cachedDeviceUuid) {
        this.cachedDeviceUuid = this.generateUUID();
      }
      return this.cachedDeviceUuid;
    }
  }, {
    key: "getConsentState",
    value: function getConsentState() {
      return this.currentConsent;
    }
  }, {
    key: "hasConsent",
    value: function hasConsent(category) {
      if (category === 'essential' || category === 'necessary') return true;
      if (!this.currentConsent) return false;
      if (this.currentConsent.consentStatus === 'acceptAll') return true;
      if (this.currentConsent.consentStatus === 'rejectNonEssential') return false;
      var cats = this.currentConsent.consentCategories;
      if (cats) {
        var key = category === 'marketing' || category === 'advertising' ? 'advertising' : category;
        if (typeof cats[key] === 'boolean') {
          return cats[key];
        }
      }
      return false;
    }
  }, {
    key: "onConsentChange",
    value: function onConsentChange(callback) {
      var _this2 = this;
      this.callbacks.push(callback);
      if (this.currentConsent) {
        try {
          callback(this.currentConsent);
        } catch (err) {
          console.error('Error in cookie consent callback:', err);
        }
      }
      return function () {
        _this2.callbacks = _this2.callbacks.filter(function (cb) {
          return cb !== callback;
        });
      };
    }
  }, {
    key: "showPreferences",
    value: function showPreferences() {
      var _this$currentConsent, _this$currentConsent2, _this$currentConsent3;
      if (!this.bannerEl || !this.modalEl) {
        this.showBannerAndModal();
      }
      var isAcceptAll = ((_this$currentConsent = this.currentConsent) === null || _this$currentConsent === void 0 ? void 0 : _this$currentConsent.consentStatus) === 'acceptAll';
      var isRejectAll = ((_this$currentConsent2 = this.currentConsent) === null || _this$currentConsent2 === void 0 ? void 0 : _this$currentConsent2.consentStatus) === 'rejectNonEssential';
      var cats = (_this$currentConsent3 = this.currentConsent) === null || _this$currentConsent3 === void 0 ? void 0 : _this$currentConsent3.consentCategories;
      var getVal = function getVal(key) {
        if (cats && typeof cats[key] === 'boolean') return cats[key];
        if (isAcceptAll) return true;
        if (isRejectAll) return false;
        return false;
      };
      var necessaryCheckbox = document.getElementById('lh-cc-necessary');
      if (necessaryCheckbox) necessaryCheckbox.checked = true;
      var functionalCheckbox = document.getElementById('lh-cc-functional');
      if (functionalCheckbox) functionalCheckbox.checked = getVal('functional');
      var analyticsCheckbox = document.getElementById('lh-cc-analytics');
      if (analyticsCheckbox) analyticsCheckbox.checked = getVal('analytics');
      var marketingCheckbox = document.getElementById('lh-cc-marketing');
      if (marketingCheckbox) marketingCheckbox.checked = getVal('advertising');
      var uncategorizedCheckbox = document.getElementById('lh-cc-uncategorized');
      if (uncategorizedCheckbox) uncategorizedCheckbox.checked = getVal('uncategorized');
      if (this.modalEl) {
        this.modalEl.classList.add('lh-cc-active');
        var card = this.modalEl.querySelector('.lh-cc-modal-card');
        if (card) card.classList.add('lh-cc-active');
        var closeBtn = document.getElementById('lh-cc-modal-close');
        if (closeBtn) closeBtn.focus();
      }
    }
  }, {
    key: "showBannerAndModal",
    value: function showBannerAndModal() {
      this.injectStyles();
      this.createModal();
      if (!this.currentConsent) {
        this.createBanner();
      }
    }
  }, {
    key: "readConsentCookie",
    value: function readConsentCookie() {
      var nameEQ = this.cookieName + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
          try {
            var jsonStr = c.substring(nameEQ.length);
            var parsed = JSON.parse(jsonStr);
            if (parsed && parsed.consentStatus) {
              return parsed;
            }
          } catch (e) {
            console.warn('Failed to parse cookie consent JSON:', e);
          }
        }
      }
      return null;
    }
  }, {
    key: "writeConsentCookie",
    value: function writeConsentCookie(consent) {
      var value = JSON.stringify(consent);
      var maxAge = this.expirationDays * 24 * 60 * 60;
      var expires = new Date(Date.now() + this.expirationDays * 24 * 60 * 60 * 1000).toUTCString();
      var hostname = window.location.hostname;
      var isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
      var domainStr = '';
      if (!isLocalhost && !/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        var targetDomain = this.domain && hostname.endsWith(this.domain.replace(/^\./, '')) ? this.domain : hostname;
        domainStr = "; Domain=".concat(targetDomain);
      }
      var isSecure = window.location.protocol === 'https:' || hostname === 'localhost' || hostname === '127.0.0.1';
      var secureStr = isSecure ? '; Secure' : '';
      document.cookie = "".concat(this.cookieName, "=").concat(encodeURIComponent(value)).concat(domainStr, "; Path=/; SameSite=Lax; Max-Age=").concat(maxAge, "; Expires=").concat(expires).concat(secureStr);
      this.currentConsent = consent;
      this.triggerCallbacks(consent);
      this.sendConsentToTrackerApi(consent);
    }
  }, {
    key: "sendConsentToTrackerApi",
    value: function () {
      var _sendConsentToTrackerApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(consent) {
        var trackerBaseUrl, url, sourceVal, payload, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              trackerBaseUrl = process.env.VUE_APP_BASE_TRACKER_API || 'https://tracker-api-us.lifehikes.com';
              url = "".concat(trackerBaseUrl.replace(/\/$/, ''), "/v1/cookie-consents");
              sourceVal = typeof window !== 'undefined' && window.location && window.location.hostname ? window.location.hostname : Constants.SOURCE_ADMIN_PORTAL || 'adminPortal';
              payload = {
                deviceUuid: consent.deviceUuid,
                source: sourceVal,
                consentStatus: consent.consentStatus,
                consentCategories: consent.consentCategories,
                submitAt: consent.timestamp
              };
              _context.n = 1;
              return fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              });
            case 1:
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.warn('Failed to send cookie consent to tracker API:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function sendConsentToTrackerApi(_x) {
        return _sendConsentToTrackerApi.apply(this, arguments);
      }
      return sendConsentToTrackerApi;
    }()
  }, {
    key: "triggerCallbacks",
    value: function triggerCallbacks(consent) {
      this.callbacks.forEach(function (callback) {
        try {
          callback(consent);
        } catch (err) {
          console.error('Error in cookie consent callback:', err);
        }
      });
    }
  }, {
    key: "injectStyles",
    value: function injectStyles() {
      if (this.styleEl) return;
      var style = document.createElement('style');
      style.id = 'lh-cookie-consent-styles';
      style.innerHTML = "\n      .lh-cc-container {\n        font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n        box-sizing: border-box;\n      }\n      .lh-cc-container * {\n        box-sizing: border-box;\n        margin: 0;\n        padding: 0;\n      }\n      .lh-cc-banner {\n        position: fixed;\n        bottom: 24px;\n        right: 24px;\n        max-width: 440px;\n        width: calc(100% - 48px);\n        background: rgba(255, 255, 255, 0.95);\n        backdrop-filter: blur(16px) saturate(180%);\n        -webkit-backdrop-filter: blur(16px) saturate(180%);\n        border: 1px solid rgba(226, 232, 240, 0.8);\n        border-radius: 16px;\n        box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);\n        padding: 24px;\n        z-index: 99999;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        opacity: 0;\n        transform: translateY(40px);\n        transition: opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1), transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n      }\n      .lh-cc-banner.lh-cc-show {\n        opacity: 1;\n        transform: translateY(0);\n      }\n      .lh-cc-title-row {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n      .lh-cc-icon {\n        width: 24px;\n        height: 24px;\n        fill: #0056FF;\n      }\n      .lh-cc-title {\n        font-size: 18px;\n        font-weight: 700;\n        color: #282B2E;\n      }\n      .lh-cc-description {\n        font-size: 14px;\n        line-height: 1.5;\n        color: #5A626A;\n      }\n      .lh-cc-policy-link {\n        color: #0056FF;\n        text-decoration: none;\n        font-weight: 600;\n      }\n      .lh-cc-policy-link:hover {\n        text-decoration: underline;\n      }\n      .lh-cc-actions {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n      }\n      .lh-cc-button-group {\n        display: flex;\n        gap: 12px;\n        width: 100%;\n      }\n      .lh-cc-btn {\n        flex: 1;\n        padding: 11px 16px;\n        font-size: 14px;\n        font-weight: 600;\n        border-radius: 8px;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.2s, color 0.2s, transform 0.1s, border-color 0.2s;\n        text-align: center;\n        white-space: nowrap;\n      }\n      .lh-cc-btn-primary {\n        background-color: #0056FF;\n        color: #ffffff;\n      }\n      .lh-cc-btn-primary:hover {\n        background-color: #0040bd;\n      }\n      .lh-cc-btn-primary:active {\n        transform: scale(0.98);\n      }\n      .lh-cc-btn-secondary {\n        background-color: transparent;\n        color: #282B2E;\n        border: 1px solid #CED4D9;\n      }\n      .lh-cc-btn-secondary:hover {\n        background-color: rgba(40, 43, 46, 0.05);\n        border-color: #282B2E;\n      }\n      .lh-cc-btn-secondary:active {\n        transform: scale(0.98);\n      }\n      .lh-cc-manage-link {\n        font-size: 14px;\n        font-weight: 600;\n        color: #0056FF;\n        background: none;\n        border: none;\n        cursor: pointer;\n        text-align: center;\n        text-decoration: underline;\n        padding: 4px 8px;\n        align-self: center;\n      }\n      .lh-cc-manage-link:hover {\n        color: #0040bd;\n      }\n      .lh-cc-modal-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(26, 32, 44, 0.5);\n        backdrop-filter: blur(8px);\n        -webkit-backdrop-filter: blur(8px);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 100000;\n        opacity: 0;\n        pointer-events: none;\n        transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n      }\n      .lh-cc-modal-overlay.lh-cc-active {\n        opacity: 1;\n        pointer-events: auto;\n      }\n      .lh-cc-modal-card {\n        background-color: #ffffff;\n        border-radius: 20px;\n        width: 70%;\n        max-width: 70%;\n        box-shadow: 0 24px 60px rgba(0, 0, 0, 0.15);\n        padding: 32px;\n        margin: 20px;\n        transform: scale(0.94);\n        transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        max-height: calc(100vh - 40px);\n        overflow-y: auto;\n      }\n      .lh-cc-modal-card.lh-cc-active {\n        transform: scale(1);\n      }\n      .lh-cc-modal-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: 1px solid #F0F6F8;\n        padding-bottom: 16px;\n      }\n      .lh-cc-modal-title {\n        font-size: 20px;\n        font-weight: 700;\n        color: #282B2E;\n      }\n      .lh-cc-modal-description {\n        font-size: 14px;\n        line-height: 1.5;\n        color: #5A626A;\n      }\n      .lh-cc-modal-close-btn {\n        background: none;\n        border: none;\n        cursor: pointer;\n        font-size: 24px;\n        color: #CED4D9;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        transition: background-color 0.2s, color 0.2s;\n      }\n      .lh-cc-modal-close-btn:hover {\n        background-color: #F0F6F8;\n        color: #282B2E;\n      }\n      .lh-cc-modal-body {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n      }\n      .lh-cc-category-card {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 16px;\n        padding: 16px;\n        background-color: #F0F6F8;\n        border-radius: 12px;\n        transition: background-color 0.2s;\n      }\n      .lh-cc-category-card:hover {\n        background-color: #E2EBF0;\n      }\n      .lh-cc-category-details {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        flex: 1;\n      }\n      .lh-cc-category-header {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n      .lh-cc-category-name {\n        font-size: 15px;\n        font-weight: 600;\n        color: #282B2E;\n      }\n      .lh-cc-badge-required {\n        font-size: 11px;\n        font-weight: 700;\n        color: #0056FF;\n        background-color: #e0ebff;\n        padding: 2px 8px;\n        border-radius: 12px;\n        text-transform: uppercase;\n      }\n      .lh-cc-category-desc {\n        font-size: 13px;\n        line-height: 1.5;\n        color: #5A626A;\n      }\n      .lh-cc-switch {\n        position: relative;\n        display: inline-block;\n        width: 46px;\n        height: 26px;\n        flex-shrink: 0;\n      }\n      .lh-cc-switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n      }\n      .lh-cc-slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #CED4D9;\n        transition: .3s;\n        border-radius: 34px;\n      }\n      .lh-cc-slider:before {\n        position: absolute;\n        content: \"\";\n        height: 20px;\n        width: 20px;\n        left: 3px;\n        bottom: 3px;\n        background-color: #ffffff;\n        transition: .3s;\n        border-radius: 50%;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n      .lh-cc-switch input:checked + .lh-cc-slider {\n        background-color: #0056FF;\n      }\n      .lh-cc-switch input:checked + .lh-cc-slider:before {\n        transform: translateX(20px);\n      }\n      .lh-cc-switch input:disabled + .lh-cc-slider {\n        background-color: #D8DEE2;\n        cursor: not-allowed;\n      }\n      .lh-cc-switch input:disabled + .lh-cc-slider:before {\n        background-color: #f5f5f5;\n      }\n      .lh-cc-btn:focus-visible,\n      .lh-cc-manage-link:focus-visible,\n      .lh-cc-modal-close-btn:focus-visible,\n      .lh-cc-policy-link:focus-visible {\n        outline: 3px solid #0056FF;\n        outline-offset: 2px;\n      }\n      .lh-cc-switch input:focus-visible + .lh-cc-slider {\n        outline: 3px solid #0056FF;\n        outline-offset: 3px;\n      }\n      .lh-cc-modal-footer {\n        display: flex;\n        justify-content: flex-end;\n        gap: 12px;\n        border-top: 1px solid #F0F6F8;\n        padding-top: 16px;\n      }\n      .lh-cc-btn-save {\n        background-color: #0056FF;\n        color: #ffffff;\n        flex: none;\n        width: 150px;\n      }\n      .lh-cc-btn-save:hover {\n        background-color: #0040bd;\n      }\n      @media (max-width: 480px) {\n        .lh-cc-banner {\n          bottom: 0;\n          right: 0;\n          width: 100%;\n          max-width: 100%;\n          border-radius: 16px 16px 0 0;\n          border-left: none;\n          border-right: none;\n          border-bottom: none;\n          padding: 20px;\n        }\n        .lh-cc-button-group {\n          flex-direction: column;\n        }\n        .lh-cc-modal-card {\n          width: calc(100% - 20px);\n          max-width: 100%;\n          margin: 10px;\n          padding: 20px;\n          gap: 18px;\n        }\n        .lh-cc-category-card {\n          padding: 12px;\n        }\n      }\n    ";
      this.styleEl = style;
      document.head.appendChild(style);
    }
  }, {
    key: "createBanner",
    value: function createBanner() {
      var _document$getElementB,
        _this3 = this,
        _document$getElementB2,
        _document$getElementB3,
        _document$getElementB4;
      if (this.bannerEl) return;
      var container = document.createElement('div');
      container.className = 'lh-cc-container';
      var banner = document.createElement('div');
      banner.className = 'lh-cc-banner';
      banner.setAttribute('role', 'status');
      banner.setAttribute('aria-live', 'polite');
      banner.innerHTML = "\n      <div class=\"lh-cc-title-row\">\n        <svg class=\"lh-cc-icon\" viewBox=\"0 0 24 24\">\n          <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.5 16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm3-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2-5c-.83 0-1.5-.67-1.5-1.5S9.17 5 10 5s1.5.67 1.5 1.5S10.83 7 10 7zm5 0c-.83 0-1.5-.67-1.5-1.5S14.17 5 15 5s1.5.67 1.5 1.5S15.83 7 15 7z\"/>\n        </svg>\n        <span class=\"lh-cc-title\">We Value Your Privacy</span>\n      </div>\n      <p class=\"lh-cc-description\">\n        This website uses cookies and similar technologies to enhance your experience and optimize our services. Please click Accept All, Reject Non-Essential, or Customize. For details, please refer to our \n        <a class=\"lh-cc-policy-link\" href=\"".concat(this.privacyPolicyUrl, "\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a> or \n        <a class=\"lh-cc-policy-link\" href=\"#\" id=\"lh-cc-link-cookie-settings\">Cookie Settings</a>.\n      </p>\n      <div class=\"lh-cc-actions\">\n        <div class=\"lh-cc-button-group\">\n          <button class=\"lh-cc-btn lh-cc-btn-primary\" id=\"lh-cc-accept-all\">Accept All</button>\n          <button class=\"lh-cc-btn lh-cc-btn-secondary\" id=\"lh-cc-reject-all\">Reject Non-Essential</button>\n        </div>\n        <button class=\"lh-cc-manage-link\" id=\"lh-cc-manage-settings\">Customize</button>\n      </div>\n    ");
      container.appendChild(banner);
      document.body.appendChild(container);
      this.bannerEl = banner;
      setTimeout(function () {
        if (banner) banner.classList.add('lh-cc-show');
      }, 100);
      (_document$getElementB = document.getElementById('lh-cc-accept-all')) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener('click', function () {
        return _this3.handleAcceptAll();
      });
      (_document$getElementB2 = document.getElementById('lh-cc-reject-all')) === null || _document$getElementB2 === void 0 || _document$getElementB2.addEventListener('click', function () {
        return _this3.handleRejectNonEssential();
      });
      (_document$getElementB3 = document.getElementById('lh-cc-manage-settings')) === null || _document$getElementB3 === void 0 || _document$getElementB3.addEventListener('click', function () {
        return _this3.showPreferences();
      });
      (_document$getElementB4 = document.getElementById('lh-cc-link-cookie-settings')) === null || _document$getElementB4 === void 0 || _document$getElementB4.addEventListener('click', function (e) {
        e.preventDefault();
        _this3.showPreferences();
      });
    }
  }, {
    key: "createModal",
    value: function createModal() {
      var _document$getElementB5,
        _this4 = this,
        _document$getElementB6,
        _document$getElementB7;
      if (this.modalEl) return;
      var overlay = document.createElement('div');
      overlay.className = 'lh-cc-modal-overlay lh-cc-container';
      overlay.id = 'lh-cc-modal-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'lh-cc-modal-title');
      overlay.innerHTML = "\n      <div class=\"lh-cc-modal-card\">\n        <div class=\"lh-cc-modal-header\">\n          <h2 class=\"lh-cc-modal-title\" id=\"lh-cc-modal-title\">Cookie Settings</h2>\n          <button class=\"lh-cc-modal-close-btn\" id=\"lh-cc-modal-close\" aria-label=\"Close settings\">&times;</button>\n        </div>\n        <div class=\"lh-cc-modal-body\">\n          <div class=\"lh-cc-category-card\">\n            <div class=\"lh-cc-category-details\">\n              <div class=\"lh-cc-category-header\">\n                <span class=\"lh-cc-category-name\">Necessary Cookies</span>\n                <span class=\"lh-cc-badge-required\">Always Active</span>\n              </div>\n              <p class=\"lh-cc-category-desc\">\n                These cookies are required for the website to load and function at its most basic level. They may include cookies used for authentication, session management, consent status, and website security. Necessary cookies cannot be disabled through the cookie settings.\n              </p>\n            </div>\n            <label class=\"lh-cc-switch\">\n              <input type=\"checkbox\" id=\"lh-cc-necessary\" checked disabled aria-label=\"Necessary cookies toggle\">\n              <span class=\"lh-cc-slider\"></span>\n            </label>\n          </div>\n          <div class=\"lh-cc-category-card\">\n            <div class=\"lh-cc-category-details\">\n              <div class=\"lh-cc-category-header\">\n                <span class=\"lh-cc-category-name\">Functional Cookies</span>\n              </div>\n              <p class=\"lh-cc-category-desc\">\n                These cookies and related technologies support enhanced website features, such as embedded videos, scheduling tools, forms, fonts, language settings, and other third-party functionality. These cookies are disabled by default and will only be enabled if you accept them.\n              </p>\n            </div>\n            <label class=\"lh-cc-switch\">\n              <input type=\"checkbox\" id=\"lh-cc-functional\" aria-label=\"Functional cookies toggle\">\n              <span class=\"lh-cc-slider\"></span>\n            </label>\n          </div>\n          <div class=\"lh-cc-category-card\">\n            <div class=\"lh-cc-category-details\">\n              <div class=\"lh-cc-category-header\">\n                <span class=\"lh-cc-category-name\">Analytics Cookies</span>\n              </div>\n              <p class=\"lh-cc-category-desc\">\n                These cookies help us understand how visitors use our website so we can monitor website usage, improve performance, and refine our services. These cookies are disabled by default and will only be enabled if you accept them.\n              </p>\n            </div>\n            <label class=\"lh-cc-switch\">\n              <input type=\"checkbox\" id=\"lh-cc-analytics\" aria-label=\"Analytics cookies toggle\">\n              <span class=\"lh-cc-slider\"></span>\n            </label>\n          </div>\n          <div class=\"lh-cc-category-card\">\n            <div class=\"lh-cc-category-details\">\n              <div class=\"lh-cc-category-header\">\n                <span class=\"lh-cc-category-name\">Advertising / Marketing Cookies</span>\n              </div>\n              <p class=\"lh-cc-category-desc\">\n                These cookies and related technologies may be used to measure advertising performance, support marketing campaigns, or deliver more relevant content. These cookies are disabled by default and will only be enabled if you accept them.\n              </p>\n            </div>\n            <label class=\"lh-cc-switch\">\n              <input type=\"checkbox\" id=\"lh-cc-marketing\" aria-label=\"Advertising and Marketing cookies toggle\">\n              <span class=\"lh-cc-slider\"></span>\n            </label>\n          </div>\n          <div class=\"lh-cc-category-card\">\n            <div class=\"lh-cc-category-details\">\n              <div class=\"lh-cc-category-header\">\n                <span class=\"lh-cc-category-name\">Uncategorized Cookies</span>\n              </div>\n              <p class=\"lh-cc-category-desc\">\n                These cookies or related technologies have not yet been categorized. They are disabled by default until they are reviewed and assigned to the correct category.\n              </p>\n            </div>\n            <label class=\"lh-cc-switch\">\n              <input type=\"checkbox\" id=\"lh-cc-uncategorized\" aria-label=\"Uncategorized cookies toggle\">\n              <span class=\"lh-cc-slider\"></span>\n            </label>\n          </div>\n        </div>\n        <div class=\"lh-cc-modal-footer\">\n          <button class=\"lh-cc-btn lh-cc-btn-secondary\" id=\"lh-cc-modal-cancel\">Cancel</button>\n          <button class=\"lh-cc-btn lh-cc-btn-primary lh-cc-btn-save\" id=\"lh-cc-save-settings\">Save Preferences</button>\n        </div>\n      </div>\n    ";
      document.body.appendChild(overlay);
      this.modalEl = overlay;
      (_document$getElementB5 = document.getElementById('lh-cc-modal-close')) === null || _document$getElementB5 === void 0 || _document$getElementB5.addEventListener('click', function () {
        return _this4.hideModal();
      });
      (_document$getElementB6 = document.getElementById('lh-cc-modal-cancel')) === null || _document$getElementB6 === void 0 || _document$getElementB6.addEventListener('click', function () {
        return _this4.hideModal();
      });
      (_document$getElementB7 = document.getElementById('lh-cc-save-settings')) === null || _document$getElementB7 === void 0 || _document$getElementB7.addEventListener('click', function () {
        return _this4.handleSavePreferences();
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) _this4.hideModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('lh-cc-active')) _this4.hideModal();
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      if (this.modalEl) {
        this.modalEl.classList.remove('lh-cc-active');
        var card = this.modalEl.querySelector('.lh-cc-modal-card');
        if (card) card.classList.remove('lh-cc-active');
      }
    }
  }, {
    key: "dismissBanner",
    value: function dismissBanner() {
      if (this.bannerEl) {
        this.bannerEl.classList.remove('lh-cc-show');
        var banner = this.bannerEl;
        setTimeout(function () {
          var _banner$parentElement;
          (_banner$parentElement = banner.parentElement) === null || _banner$parentElement === void 0 || _banner$parentElement.remove();
        }, 500);
        this.bannerEl = null;
      }
    }
  }, {
    key: "handleAcceptAll",
    value: function handleAcceptAll() {
      var consent = {
        deviceUuid: this.getOrCreateDeviceUuid(),
        consentStatus: 'acceptAll',
        consentCategories: {
          necessary: true,
          analytics: true,
          advertising: true,
          functional: true,
          uncategorized: true
        },
        timestamp: new Date().toISOString()
      };
      this.writeConsentCookie(consent);
      this.dismissBanner();
      this.hideModal();
    }
  }, {
    key: "handleRejectNonEssential",
    value: function handleRejectNonEssential() {
      var consent = {
        deviceUuid: this.getOrCreateDeviceUuid(),
        consentStatus: 'rejectNonEssential',
        consentCategories: {
          necessary: true,
          analytics: false,
          advertising: false,
          functional: false,
          uncategorized: false
        },
        timestamp: new Date().toISOString()
      };
      this.writeConsentCookie(consent);
      this.dismissBanner();
      this.hideModal();
    }
  }, {
    key: "handleSavePreferences",
    value: function handleSavePreferences() {
      var necessaryCheckbox = document.getElementById('lh-cc-necessary');
      var functionalCheckbox = document.getElementById('lh-cc-functional');
      var analyticsCheckbox = document.getElementById('lh-cc-analytics');
      var marketingCheckbox = document.getElementById('lh-cc-marketing');
      var uncategorizedCheckbox = document.getElementById('lh-cc-uncategorized');
      var isNecessary = necessaryCheckbox ? necessaryCheckbox.checked : true;
      var isFunctional = functionalCheckbox ? functionalCheckbox.checked : false;
      var isAnalytics = analyticsCheckbox ? analyticsCheckbox.checked : false;
      var isAdvertising = marketingCheckbox ? marketingCheckbox.checked : false;
      var isUncategorized = uncategorizedCheckbox ? uncategorizedCheckbox.checked : false;
      var consent = {
        deviceUuid: this.getOrCreateDeviceUuid(),
        consentStatus: 'preferencesChanged',
        consentCategories: {
          necessary: true,
          analytics: isAnalytics,
          advertising: isAdvertising,
          functional: isFunctional,
          uncategorized: isUncategorized
        },
        timestamp: new Date().toISOString()
      };
      this.writeConsentCookie(consent);
      this.dismissBanner();
      this.hideModal();
    }
  }]);
}();
var cookieConsentManager = exports.cookieConsentManager = new CookieConsentManager();
var _default = exports.default = cookieConsentManager;